import React from "react";
import Helmet from "react-helmet";

import ReactMarkdown from "react-markdown";
import NavBar from "../../components/NavBar";
import { ArrowBody } from "../../components/ArrowLink";
import { P, Description, H5 } from "../../components/typography";
import Section from "../../components/blocks/Section";
import { HideMobile } from "../../components/blocks/Responsive";
import Flex from "../../components/blocks/Flex";
import Pad from "../../components/blocks/Pad";
import Spacer from "../../components/blocks/Spacer";
import Background from "../../components/blocks/Background";
import { PostLink, PostFeature, PostBody } from "../../components/Post";

import favicon from "../../../assets/logofavcon@2x.png";
import { MetaTags } from "../../components/atoms/SocialTags";

export default props => {
  if (!props.data || !props.data.allContentfulBlogPost) return "";
  const posts = props.data.allContentfulBlogPost.edges.map(e => e.node);
  posts.sort((a, b) => new Date(b.publishDate) > new Date(a.publishDate));
  const blogPost = props.pathContext,
    postIndex = posts.findIndex(post => post.id === blogPost.id);
  if (!blogPost.title) return "";

  return (
    <div>
      <Helmet
        title="Contraline News"
        meta={[{ name: "Contraline", content: "News" }]}
      >
        <link rel="icon" type="image/png" href={favicon} />
        <MetaTags
          title={blogPost.title + " " + blogPost.subtitle}
          description={blogPost.body && blogPost.body.body}
          src={
            blogPost.headerImage &&
            blogPost.headerImage.responsiveResolution.src
          }
        />
      </Helmet>
      <NavBar color="dark" background="white" />
      <Background color="white" fixed={true}>
        <Section noBorder fixed={true} vPad={false}>
          <Pad h={2}>
            <PostFeature post={blogPost} />
          </Pad>
          <HideMobile>
            <Spacer span={2} />
          </HideMobile>
          <Pad v={2} h={2}>
            <PostBody>
              <ReactMarkdown source={blogPost.body && blogPost.body.body}>
                {blogPost.body && blogPost.body.body}
              </ReactMarkdown>
              <Spacer span={2} />
              <Flex style={{ maxWidth: "45rem" }} align="flex-start">
                <div style={{ width: 300 }}>
                  {postIndex < posts.length - 1 &&
                    <PostLink post={posts[postIndex + 1]}>
                      <Description style={{ paddingBottom: 0 }}>
                        Previous{" "}
                      </Description>
                      <P style={{ fontWeight: 500 }}>
                        {posts[postIndex + 1].title +
                          " " +
                          posts[postIndex + 1].subtitle}
                      </P>
                    </PostLink>}
                </div>
                <div style={{ width: 300 }}>
                  {0 < postIndex &&
                    <PostLink post={posts[postIndex - 1]}>
                      <Description style={{ paddingBottom: 0 }}>
                        Next
                      </Description>
                      <P style={{ fontWeight: 500 }}>
                        {posts[postIndex - 1].title +
                          " " +
                          posts[postIndex - 1].subtitle}
                      </P>
                    </PostLink>}
                </div>
              </Flex>
            </PostBody>
          </Pad>
          <Pad v={2} />
          <Spacer span={4} />
        </Section>
      </Background>
    </div>
  );
};

export const pageQuery = graphql`
  query Posts {
    allContentfulBlogPost {
      edges {
        node {
          id
          title
          subtitle
          author
          publishDate(formatString: "MMMM DD, YYYY HH:MM:SS")
          headerImage {
            id
            responsiveResolution(width: 1200, quality: 70) {
              src
            }
          }
          body {
            body
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/news/post.js